import {Component, EventEmitter, Inject, Output} from "ng-metadata/core";
import {getCaptcha} from "../../appConfig/appConfigForward";

@Component({
    selector: 'prm-captcha-popup',
    templateUrl: 'components/security/captcha/captcha-popup.html',
})
export class PrmCaptchaPopup {
    constructor(
        @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService
    ) {}
    @Output() private onCancel = new EventEmitter();
    @Output() private onResponse = new EventEmitter<string>();

    private _captchaResponse: string = "";
    private _captchaConfigValue = getCaptcha();
    private _widgetId: string = '';

    public closePopup() {
        this.$mdDialog.cancel();
        this.onCancel.emit(null);
    }

    get capchaPublicKey() {
        return this._captchaConfigValue.public_key;
    }

    public setResponse(response) {
        this._captchaResponse = response;
        this.onResponse.emit(response);
    }

    public setWidgetId(widgetId: string) {
        this._widgetId = widgetId;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/captcha/captcha-popup.ts